import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";

import reducers from "./Reducers";

export default function configureStore() {
  let store = createStore(reducers, applyMiddleware(thunk));
  return store;
}
